"use client"

import { useCallback, useEffect, useSyncExternalStore } from 'react'
import useSWR from 'swr'
import storage from '@utils/localStorage'
import useT from '@hooks/useTranslation'
import toggleWatch from 'lib/watch/toggleWatch'
import { WATCH_LIMIT } from 'lib/watch/limits'
import { getVersion, isWatched, loadGuest, register, setToken, subscribe } from 'lib/watch/watchStore'

export const LIMIT_TEXT = `Obserwujesz już ${WATCH_LIMIT} ogłoszeń — to najwięcej. Usuń część z obserwowanych, aby dodać nowe.`

// Teksty komunikatów obserwowania.
export function useWatchTexts () {
    return {
        guestAdded: useT('Dodano do obserwowanych. Zaloguj się, aby dostawać powiadomienia o obniżce ceny.'),
        loginAction: useT('Zaloguj się'),
        undo: useT('Cofnij'),
        added: useT('Dodano do obserwowanych'),
        removed: useT('Usunięto z obserwowanych'),
        error: useT('Nie udało się zapisać. Spróbuj ponownie.'),
        limit: useT(LIMIT_TEXT),
        see: useT('Zobacz'),
        seeName: useT('Zobacz obserwowane ogłoszenia'),
    }
}

// Token zalogowanego użytkownika przekazany do wspólnego stanu obserwowanych.
export function useWatchToken () {
    const { data: user } = useSWR('user', storage)
    const token = user?.token || null
    useEffect(() => { setToken(token) }, [token])
    return token
}

// Stan i kliknięcie serca obserwowania na stronie ogłoszenia (karty: WatchController).
export default function useWatched ({ id, type }) {
    const token = useWatchToken()
    const t = useWatchTexts()

    useEffect(() => { if (token && id) register(id) }, [token, id])
    useEffect(() => { if (!token) loadGuest() }, [token])
    useSyncExternalStore(subscribe, getVersion, () => 0)

    const onClick = useCallback((event) => {
        toggleWatch({ id, type, opener: event?.currentTarget, t })
    }, [id, type]) // eslint-disable-line react-hooks/exhaustive-deps

    return { on: isWatched(id), onClick }
}
